<template>
  <section class="section">
    <title-bar>
      All Shareholder
      <span class="number-of-user" v-if="totalUsers">({{ totalUsers }})</span>
      <!-- <CreateNewUserModal slot="button" class="level-item" /> -->
      <div class="level-item action" slot="button">
        <router-link to="/" class="button is-primary" slot="button">Dashboard</router-link>
      </div>
    </title-bar>
    <div id="autocomplete" class="autocomplete">
      <!-- <input
        v-model="searchTerm"
        @input="searchUpdated"
        class="autocomplete-input"
        placeholder="Search for User Names"
        aria-label="Search for an User Name"
      /> -->
      <input
        v-model="searchTerm"
        class="autocomplete-input  search-input"
        placeholder="Search"
        aria-label="Search"
      />
      <select v-model="searchType" class="autocomplete-input search-type" >
                <option value="name" selected="selected">Name</option>
                <option value="citizen">Citizenship No</option>
                <option value="share">Shareholder No</option>
                <option value="mobile">Mobile</option>
       </select>
       <p class="buttons">
       <button
          class="button custom_button"
            @click="searchUpdated('search')"
            style="margin-left:10px;"
          >
            <span class="icon is-large">
            <i class="fas fa-search"></i>
            </span>
            <span>Search</span>
        </button>
       </p>

    </div>
        <div>
             <b-upload v-model="CSVfile" @input="uploadCSV" accept=".csv">
            <a class="button is-danger">
              <b-icon icon="upload" custom-size="default"></b-icon>
              <span>{{ formCSVLabel }}</span>
            </a>
          </b-upload>
<button type="button" class="button is-primary saveAsExcel" style="margin-left:10px;">Export current page</button> 
          <button
          type="button"
            @click="exportData"
            class="button is-primary"
            style="margin-left:10px;"
          >
            Export all data
          </button>
          <button
          type="button"
          v-if="this.$store.state.citizens.searchedValue == 1"
            @click="searchUpdated('clear')"
            class="button is-danger"
            style="margin-left:10px;"
          >
            Clear Search
        </button>
      </div>
    <card-component id="mytable" class="has-table" title="Shareholders" icon="account-multiple">
      <CitizensTable v-if="!isLoading" :checkable="false" :searchTe="this.searchTerm" :searchTy="this.searchType"/>

      <h4 v-else>Loading...</h4>
    </card-component>

    <hr />

    <!-- <notification class="is-primary">
      <div>
        <b-icon icon="buffer" custom-size="default" />
        <b>Tightly wrapped</b> &mdash; table header becomes a card header
      </div>
    </notification>

    <card-component class="has-table has-mobile-sort-spaced">
      <clients-table-sample data-url="/data-sources/clients.json" :checkable="true" />
    </card-component>

    <hr />-->

    <!-- <notification class="is-primary">
      <div>
        <b-icon icon="buffer" custom-size="default" />
        <b>Empty table.</b> When there's nothing to show
      </div>
    </notification>-->

    <!-- <card-component class="has-table">
      <clients-table-sample />
    </card-component>-->
  </section>
</template>

<script>
import Notification from '@/components/Notification';
import ClientsTableSample from '@/components/ClientsTableSample';
import CardComponent from '@/components/CardComponent';
import TitleBar from '@/components/TitleBar';
import CitizensTable from '../components/Citizens/CitizensTable';
import axiosInstance from '../services/axios';
import { getAPIEndpoint } from '../helpers';
import axios from 'axios';
import $ from 'jquery';
import XLSX from 'xlsx';
// import CreateNewUserModal from '../components/Users/CreateNewUserModal';
export default {
  data() {
    return {
      CSVfile: null,
      searchTerm: '',
      searchType: 'name',
      totalUsers: null,
      isLoading: false,
      citizens: [],
      form: {
        csv_file: null
      }
    };
  },
  name: 'Tables',
  components: { TitleBar, CardComponent, CitizensTable},
  mounted() {
    this.$store.commit('isNavBarVisible', true);
  },
  methods: {
    searchUpdated(value) {
      this.isLoading = true;
      let filter = {};
      if(value == 'clear'){
        this.searchTerm = '';
      }
      if (this.searchTerm.includes('=')) {
        var keyVal = this.searchTerm.split('=');

        filter[keyVal[0]] = keyVal[1];
      } else {
        filter = {
          searchTerm: this.searchTerm,
          searchType: this.searchType,
          limit: 10,
        };
      }
      
      this.$store
        .dispatch('citizens/fetchCitizens', {
          filter: filter,
          // searchType: this.searchType,
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
      uploadCSV(CSVfile) {
      this.isUploading = true;
      this.$emit('input', CSVfile);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('csv', CSVfile);
      // console.log(CSVfile);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/importCSV`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.csv_file = res.data.imageUrl;
          this.isUploading = false;
          this.$buefy.snackbar.open({
            message: 'Data Imported Successfully',
            queue: false,
          });
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
    exportData(){
      // this.isLoading = true;
      this.$buefy.toast.open({
          message: `Your file is dowloading....`,
          type: 'is-info',
        });
      this.$store
      .dispatch('citizens/extractData')
      .then(() => {
       this.$buefy.toast.open({
          message: `Downloaded`,
          type: 'is-success',
        });
      })
      .catch((err) => {
        this.isLoading = false;
        this.$buefy.toast.open({
          message: `Error: ${err.message}`,
          type: 'is-danger',
        });
      });
    }
  },
  computed: {
    formCSVLabel() {
      return !this.CSVfile ? 'Upload CSV' : 'Another CSV';
    },
    },
  created() {
    this.searchUpdated();
    this.totalUsers = this.$store.state.dashboard.dashboard.citizenCount;
  },
};

$(document).ready(function(){
    $(".saveAsExcel").click(function(){
        var workbook = XLSX.utils.book_new();
        
        //var worksheet_data  =  [['hello','world']];
        //var worksheet = XLSX.utils.aoa_to_sheet(worksheet_data);
      
        var worksheet_data  = document.getElementById("mytable");
        var worksheet = XLSX.utils.table_to_sheet(worksheet_data);

        delete_cols(worksheet, 0, 1);

        workbook.SheetNames.push("Test");
        workbook.Sheets["Test"] = worksheet;

         exportExcelFile(workbook);
      
     
    });
})

function clamp_range(range) {
	if(range.e.r >= (1<<20)) range.e.r = (1<<20)-1;
	if(range.e.c >= (1<<14)) range.e.c = (1<<14)-1;
	return range;
}

function delete_cols(ws, start_col, ncols) {
  var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.(A-Za-z0-9])/g;

	if(!ws) throw new Error("operation expects a worksheet");
	var dense = Array.isArray(ws);
	if(!ncols) ncols = 1;
	if(!start_col) start_col = 0;

	/* extract original range */
	var range = XLSX.utils.decode_range(ws["!ref"]);
	var R = 0, C = 0;

	var formula_cb = function($0, $1, $2, $3, $4, $5) {
		var _R = XLSX.utils.decode_row($5), _C = XLSX.utils.decode_col($3);
		if(_C >= start_col) {
			_C -= ncols;
			if(_C < start_col) return "#REF!";
		}
		return $1+($2=="$" ? $2+$3 : XLSX.utils.encode_col(_C))+($4=="$" ? $4+$5 : XLSX.utils.encode_row(_R));
	};

	var addr, naddr;
	for(C = start_col + ncols; C <= range.e.c; ++C) {
		for(R = range.s.r; R <= range.e.r; ++R) {
			addr = XLSX.utils.encode_cell({r:R, c:C});
			naddr = XLSX.utils.encode_cell({r:R, c:C - ncols});
			if(!ws[addr]) { delete ws[naddr]; continue; }
			if(ws[addr].f) ws[addr].f = ws[addr].f.replace(crefregex, formula_cb);
			ws[naddr] = ws[addr];
		}
	}
	for(C = range.e.c; C > range.e.c - ncols; --C) {
		for(R = range.s.r; R <= range.e.r; ++R) {
			addr = XLSX.utils.encode_cell({r:R, c:C});
			delete ws[addr];
		}
	}
	for(C = 0; C < start_col; ++C) {
		for(R = range.s.r; R <= range.e.r; ++R) {
			addr = XLSX.utils.encode_cell({r:R, c:C});
			if(ws[addr] && ws[addr].f) ws[addr].f = ws[addr].f.replace(crefregex, formula_cb);
		}
	}

	/* write new range */
	range.e.c -= ncols;
	if(range.e.c < range.s.c) range.e.c = range.s.c;
	ws["!ref"] = XLSX.utils.encode_range(clamp_range(range));

	/* merge cells */
	if(ws["!merges"]) ws["!merges"].forEach(function(merge, idx) {
		var mergerange;
		switch(typeof merge) {
			case 'string': mergerange = XLSX.utils.decode_range(merge); break;
			case 'object': mergerange = merge; break;
			default: throw new Error("Unexpected merge ref " + merge);
		}
		if(mergerange.s.c >= start_col) {
			mergerange.s.c = Math.max(mergerange.s.c - ncols, start_col);
			if(mergerange.e.c < start_col + ncols) { delete ws["!merges"][idx]; return; }
			mergerange.e.c -= ncols;
			if(mergerange.e.c < mergerange.s.c) { delete ws["!merges"][idx]; return; }
		} else if(mergerange.e.c >= start_col) mergerange.e.c = Math.max(mergerange.e.c - ncols, start_col);
		clamp_range(mergerange);
		ws["!merges"][idx] = mergerange;
	});
	if(ws["!merges"]) ws["!merges"] = ws["!merges"].filter(function(x) { return !!x; });

	/* cols */
	if(ws["!cols"]) ws["!cols"].splice(start_col, ncols);
}

function exportExcelFile(workbook) {
    return XLSX.writeFile(workbook, "memberData.xlsx");
}
</script>

<style scoped lang="scss">
.is-title-bar {
  margin-bottom: 1rem;
}

#autocomplete {
  max-width: 700px;
  margin: 0 auto;
  display: flex;
}

.search-input {
  margin-bottom: 13px;
  flex: 0 0 60%;
}
.search-button{
flex: 0 0 10%;
background-color: #4B77FB;
/*background-image: none;*/
margin-bottom: 13px;
text-align: center;
color: white;
    

}
.search-type{
flex: 0 0 30%;
margin-bottom: 13px;
background-image: none;
margin-left: 12px;
}


.autocomplete-result-list {
  margin-bottom: 10px;
}

@media screen and (max-width: 768px) {
  .level-item:not(:last-child) {
    margin-bottom: 0;
    margin: 10px;
  }
}

.number-of-user {
  color: blue($color: #000000);
}
.custom_button{
margin-bottom: 20px;
background-color: #4B77FB;
color: white;
}
</style>
